import { render, staticRenderFns } from "./DepartmentList.vue?vue&type=template&id=e59f38dc&scoped=true&"
import script from "./DepartmentList.vue?vue&type=script&lang=js&"
export * from "./DepartmentList.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentList.vue?vue&type=style&index=0&id=e59f38dc&prod&scoped=true&lang=css&"
import style1 from "./DepartmentList.vue?vue&type=style&index=1&id=e59f38dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59f38dc",
  null
  
)

export default component.exports